import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BookPdfFlipbookComponent } from './tabs/book-pdf-flipbook/book-pdf-flipbook.component';
import { HistoricDemoComponent } from './demo/historic-demo/historic-demo.component';
import { AccessLocatorComponent } from './tabs/access-locator/access-locator.component';
import { RecoverMailComponent } from './tabs/recover-mail/recover-mail.component';

const routes: Routes = [
  { path: 'book-pdf', component: BookPdfFlipbookComponent },
  { path: 'historic', component: HistoricDemoComponent },
  { path: 'acceso', component: AccessLocatorComponent },
  { path: 'recovermail', component: RecoverMailComponent },
  { path: '', redirectTo: '/acceso', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
